import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from "../redux/actions/index";
import AppLoader from "../utils/AppLoader";
import stringTamil from "../utils/stringTamil";
import stringEnglish from "../utils/stringEnglish";
import SRM_GLOBAL from "../assets/img/srm-global.jpeg";
import Constants from "../utils/Constants";
import { toast } from "react-toastify";

class SrmIpRoomList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {},
      message: {},
      vendorLogo: null,
      language: parseInt(localStorage.getItem("language")) || 1,
      roomList: [],
      filteredRoomList: [],
      searchQuery: "",
      isLoading: false
    };
  }

  async componentDidMount() {
    localStorage?.clear();
    const vendorId = this.props.match.params.vendor_id;
    
    // If vendor_id is missing, redirect to error page
    if (!vendorId || vendorId.trim() === '') {
      toast.error("Invalid vendor ID");
      this.props.history.push('/pageNotFound');
      return;
    }
    
    this.setState({ vendorId: vendorId });
    this.fetchRoomList(vendorId);
  }

  fetchRoomList = (vendorId) => {
    const params = {
      vendor_id: vendorId
    };
    const callback = (response) => {
      this.setState({ isLoading: false });
      if (response?.response_code === 0) {
        const rooms = response?.response?.rooms || response?.response || [];
        // Sort rooms by patientRoomName alphabetically
        const sortedRooms = rooms.sort((a, b) => {
          const nameA = (a?.patientRoomName || a?.roomName || '').toLowerCase();
          const nameB = (b?.patientRoomName || b?.roomName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        this.setState({ 
          roomList: sortedRooms,
          filteredRoomList: sortedRooms 
        });
      } else {
        toast.error(response?.response_message || "Failed to load rooms");
      }
    };
    this.setState({ isLoading: true });
    this.props.srmIpRoomListAction(params, callback);
  };

  handleSearch = (e) => {
    const searchQuery = e.target.value;
    this.setState({ searchQuery });
    
    // Only show results if search query has at least 3 characters
    if (!searchQuery.trim() || searchQuery.trim().length < 3) {
      this.setState({ filteredRoomList: [] });
      return;
    }

    const searchQueryLower = searchQuery.toLowerCase();
    const filtered = this.state.roomList.filter((room) => {
      const patientRoomName = room?.patientRoomName?.toLowerCase() || "";
      const patientRoomId = room?.patientRoomId?.toString().toLowerCase() || "";
      const roomCode = room?.roomCode?.toLowerCase() || "";
      const roomName = room?.roomName?.toLowerCase() || "";
      const encryptRoomId = room?.encryptRoomId?.toLowerCase() || "";
      
      return (
        patientRoomName.includes(searchQueryLower) ||
        patientRoomId.includes(searchQueryLower) ||
        roomCode.includes(searchQueryLower) ||
        roomName.includes(searchQueryLower) ||
        encryptRoomId.includes(searchQueryLower)
      );
    });

    this.setState({ filteredRoomList: filtered });
  };

  handleRoomClick = (room) => {
    const encryptRoomId = room?.encryptRoomId;
    const vendorId = this.state.vendorId || this.props.match.params.vendor_id;
    
    if (encryptRoomId && vendorId) {
      this.props.history.push(`/SRM_IP/patient/${vendorId}/${encryptRoomId}`);
    } else {
      toast.error("Invalid room code or vendor ID");
    }
  };

  render() {
    const { language, isLoading, filteredRoomList, searchQuery } = this.state;
    let MESSAGE = language === 2 ? stringTamil?.MESSAGE : stringEnglish?.MESSAGE;

    return (
      <div
        className="customer-care overflow-auto"
        style={{
          backgroundImage: `url(${SRM_GLOBAL})`,
          backgroundSize: "auto 100%",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
      >
        {isLoading && <AppLoader />}
        <div className="row call-row mx-0">
          <div className="col-md-12 d-flex flex-column justify-content-center align-items-center">
            <div className="text-center mb-4">
              <img
                className="logo"
                src={require("../assets/img/srm-logo.png")}
                alt="logo"
              />
            </div>
            <div className="d-flex flex-column gap-3 width_value pb-sm-0 pb-5">
              <div
                className="d-flex gap-3 flex-column p-sm-5 p-3 rounded-4"
                style={{ backgroundColor: "rgb(255 255 255 / 80%)" }}
              >
                <div>
                  <h1 className="text-center">{MESSAGE?.SELECT_ROOM || "Select Room"}</h1>
                  <p className="text-center text-muted">
                    {MESSAGE?.SELECT_ROOM_DESCRIPTION || "Please select your room to continue"}
                  </p>
                </div>

                {/* Search Box */}
                <div className="mb-3">
                  <label htmlFor="roomSearch" className="form-label form-text">
                    {MESSAGE?.SEARCH_ROOM || "Search Room"}
                  </label>
                  <input
                    type="text"
                    className="form-control input-box-size"
                    id="roomSearch"
                    placeholder={MESSAGE?.SEARCH_ROOM_PLACEHOLDER || "Enter at least 3 characters to search..."}
                    value={searchQuery}
                    onChange={this.handleSearch}
                    style={{ height: "46px" }}
                    minLength={3}
                  />
                  {searchQuery.length > 0 && searchQuery.length < 3 && (
                    <small className="text-muted d-block mt-1">
                      {MESSAGE?.ENTER_MIN_3_CHARACTERS || "Please enter at least 3 characters to search"}
                    </small>
                  )}
                </div>

                {/* Room List */}
                <div className="row g-2">
                  {searchQuery.length >= 3 ? (
                    filteredRoomList.length > 0 ? (
                      filteredRoomList.map((room, index) => (
                        <div
                          className="col-6 col-md-4 col-lg-3"
                          key={room?.id || room?.encryptRoomId || index}
                          onClick={() => this.handleRoomClick(room)}
                          style={{ cursor: "pointer" }}
                        >
                        <button className="cat-btn btn-gradient w-100">
                          <h5 className="mb-2">
                            <i className="fas fa-door-open"></i>
                          </h5>
                          <div className="text-break" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                            {room?.patientRoomName || room?.roomName || room?.roomCode || room?.encryptRoomId}
                          </div>
                        </button>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center py-4">
                        <p className="text-muted">
                          {MESSAGE?.NO_ROOM_FOUND || "No rooms found matching your search"}
                        </p>
                      </div>
                    )
                  ) : (
                    <div className="col-12 text-center py-4">
                      <div className="d-flex flex-column align-items-center">
                        <i className="fas fa-search fa-3x text-muted mb-3"></i>
                        <p className="text-muted mb-2">
                          {MESSAGE?.ENTER_ROOM_SEARCH || "Please enter at least 3 characters to search for your room"}
                        </p>
                        <p className="text-muted small">
                          {MESSAGE?.SEARCH_HELP || "Example: Enter room number or room name"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    customerListLoader: state?.CUSTOMER_LIST,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    srmIpRoomListAction: Actions.srmIpRoomListAction,
  })(SrmIpRoomList)
);

